var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-wrap"},_vm._l((_vm.sections),function(section,index){return _c('ImageSection',{key:index,attrs:{"sectData":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }